var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('MainComponent',{attrs:{"user":_vm.user}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }